import { GET_PROJECTS, GET_PROJECTS_SUCCESS, GET_PROJECTS_ERROR } from './../../actionType.js';

const initialState = {
  projects: null,
  message: null,
  loading: false,
  success: false,
  error: false,
};

const AllProjects = (state = initialState, action) => {
  switch (action.type) {
    case GET_PROJECTS:
      state = {
        ...state,
        data: null,
        loading: true,
        success: false,
        error: false,
        message: null,
      };
      break;

    case GET_PROJECTS_SUCCESS:
      state = {
        ...state,
        data: action.payload.results,
        loading: false,
        success: true,
        error: false,
        message: null,
      };
      break;

    case GET_PROJECTS_ERROR:
      state = {
        ...state,
        data: null,
        loading: false,
        success: false,
        error: true,
        message: action.payload,
      };
      break;

    default:
      state = { ...state };
      break;
  }
  return state;
};

export default AllProjects;
